import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OrderDetails } from "./OrderDetails";

interface FormData {
  pedido_numero: string;
  email: string;
}

interface FormErrors {
  pedido_numero?: string;
  email?: string;
}

export const CheckOrder: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    pedido_numero: "",
    email: "",
  });

  const [errors, setErrors] = useState<FormErrors>({});
  const [touched, setTouched] = useState<Record<string, boolean>>({});
  const navigate = useNavigate();

  const validateField = (name: string, value: string): string | undefined => {
    if (!value.trim()) {
      return "Este campo é obrigatório";
    }
    if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "E-mail inválido";
    }
    if (name === "pedido_numero" && !/^\d+$/.test(value)) {
      return "Número do pedido deve conter apenas dígitos";
    }
    return undefined;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (touched[name]) {
      const error = validateField(name, value);
      setErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    const error = validateField(name, formData[name as keyof FormData]);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Mark all fields as touched
    const allTouched = Object.keys(formData).reduce(
      (acc, key) => ({
        ...acc,
        [key]: true,
      }),
      {}
    );
    setTouched(allTouched);

    // Validate all fields
    const newErrors: FormErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key as keyof FormData]);
      if (error) newErrors[key as keyof FormErrors] = error;
    });

    setErrors(newErrors);

    // If no errors, proceed with form submission
    if (Object.keys(newErrors).length === 0) {
      navigate("/pedido_detalhes", {
        state: {
          orderId: formData.pedido_numero,
          email: formData.email,
        },
      });
    }
  };

  return (
    <div className="container-fluid bg_branco">
      <div className="container ctn_default">
        <div className="row">
          <div className="col-md-8 col-md-push-2">
            <h1 className="titulo titulo_25 titulo_400 txt_preto mg-bt_20">
              <span className="material-symbols-outlined">find_in_page</span>
              Consultar Pedido
            </h1>

            <div className="mg-bt_40">
              <form onSubmit={handleSubmit}>
                <div className="form_row row_1-2-1">
                  <div>
                    <label className="titulo_15 titulo_700">
                      N° do Pedido*
                    </label>
                    {touched.pedido_numero && errors.pedido_numero && (
                      <div
                        className="error-message"
                        style={{
                          color: "red",
                          fontSize: "0.9em",
                          marginBottom: "5px",
                        }}
                      >
                        {errors.pedido_numero}
                      </div>
                    )}
                    <input
                      type="text"
                      name="pedido_numero"
                      value={formData.pedido_numero}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        touched.pedido_numero && errors.pedido_numero
                          ? "error-input"
                          : ""
                      }
                      style={
                        touched.pedido_numero && errors.pedido_numero
                          ? { borderColor: "red" }
                          : {}
                      }
                    />
                  </div>

                  <div>
                    <label className="titulo_15 titulo_700">Seu E-mail*</label>
                    {touched.email && errors.email && (
                      <div
                        className="error-message"
                        style={{
                          color: "red",
                          fontSize: "0.9em",
                          marginBottom: "5px",
                        }}
                      >
                        {errors.email}
                      </div>
                    )}
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        touched.email && errors.email ? "error-input" : ""
                      }
                      style={
                        touched.email && errors.email
                          ? { borderColor: "red" }
                          : {}
                      }
                    />
                  </div>
                  <div className="ctn_bt">
                    <input
                      className="bt bt_cor-id-3 bt_full"
                      type="submit"
                      value="Consultar"
                    />
                  </div>
                </div>
              </form>
            </div>

            <div>
              <h2 className="titulo_25 titulo_700 text-center">
                Não sabe o número?
              </h2>
              <p className="text-center">
                Entre em{" "}
                <Link to="/contato" title="Contato">
                  contato
                </Link>{" "}
                que iremos ajudar
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
